"use strict";

var _defineProperty = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _commonKeys;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var isMacOs = false;

if (typeof window === 'object') {
  isMacOs = window.navigator.platform === 'MacIntel';
}

var commonKeys = (_commonKeys = {}, _defineProperty(_commonKeys, isMacOs ? 'Cmd-F' : 'Ctrl-F', 'findPersistent'), _defineProperty(_commonKeys, 'Cmd-G', 'findPersistent'), _defineProperty(_commonKeys, 'Ctrl-G', 'findPersistent'), _defineProperty(_commonKeys, 'Ctrl-Left', 'goSubwordLeft'), _defineProperty(_commonKeys, 'Ctrl-Right', 'goSubwordRight'), _defineProperty(_commonKeys, 'Alt-Left', 'goGroupLeft'), _defineProperty(_commonKeys, 'Alt-Right', 'goGroupRight'), _commonKeys);
var _default = commonKeys;
exports.default = _default;